import { render, staticRenderFns } from "./BaseCardSearch.vue?vue&type=template&id=1c925b0c&scoped=true&"
import script from "./BaseCardSearch.vue?vue&type=script&lang=js&"
export * from "./BaseCardSearch.vue?vue&type=script&lang=js&"
import style0 from "./BaseCardSearch.vue?vue&type=style&index=0&id=1c925b0c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c925b0c",
  null
  
)

export default component.exports